import { render } from "./LearningDetail.vue?vue&type=template&id=6ea94574"
import script from "./LearningDetail.vue?vue&type=script&lang=ts"
export * from "./LearningDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script